import { Badge } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { demoModeKeys } from "app/pages/sales-intelligence/utils/i18n/demo-mode";

export const DemoBadge = () => {
    return <Badge type="demo">{translate(demoModeKeys.badge)}</Badge>;
};
